import { createContext, useContext } from "react";
import type { ReportColumn, ReportDataset } from "@/profitability/types";
import type { SourceTarget } from "./types";

export interface ShowSource {
  /** Opens the file beside the record's figures, on `target.column` when given. */
  open: (target: SourceTarget) => void;
  /**
   * Whether a figure (a column) or a record (no column) can show its source
   * on this page: its column names a `source`, or its dataset is `cited`.
   */
  available: (dataset: ReportDataset, column?: ReportColumn | null) => boolean;
  /** Whether the dialog is open, so what is under it ignores its Escape. */
  isOpen: boolean;
}

export const SourceContext = createContext<ShowSource | null>(null);

/** Null where the page does not offer "Show source". */
export const useShowSource = () => useContext(SourceContext);
